module.exports = __webpack_public_path__ + "img/li-circle-error.28337c54.svg";